import React from 'react'
import bg1 from '../../assets/images/bg1.svg'
import { GiWorld } from "react-icons/gi";
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import web from '../../assets/images/web.svg'
import mobile from '../../assets/images/mobile.svg'
import custom from '../../assets/images/custom.svg'

const Explore = () => {
    const { t } = useTranslation()

    return (
        <div className='explore'>
            {/* <img src={bg1} alt='' className='explore-bg' /> */}
            <div className='content'>
                {/* <div className='tabs'>
                    <div className='item'><span>{t("mobile_applications")}</span></div>
                    <div className='item'><span>{t("web_portals")}</span></div>
                    <div className='item'><span>{t("custom_software")}</span></div>
                    <div className='item active'>
                        <GiWorld />
                        <span>{t("explore")}</span>
                    </div>
                </div> */}
                <div className='title'><h2>{t("explore_text")}</h2></div>
                <Row>
                    <Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-3 d-flex justify-content-center'>
                        <div className='item'>
                            <div className='d-flex justify-content-center align-items-center w-100'>
                                <div className='logo'><img src={mobile} alt='' /></div>
                            </div>
                            <div>
                                <div className='my-3'><h4>{t("mobile_applications")}</h4></div>
                                <div className='mt-2'><span>{t("mobile_text1")}</span></div>
                                <div className='mt-2'><span>{t("mobile_text2")}</span></div>
                                <div className='mt-2'><span>{t("mobile_text3")}</span></div>
                                <div className='mt-2'><span>{t("mobile_text4")}</span></div>
                                <div className='mt-2'><span>{t("mobile_text5")}</span></div>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-3 d-flex justify-content-center'>
                        <div className='item'>
                            <div className='d-flex justify-content-center align-items-center w-100'>
                                <div className='logo'><img src={web} alt='' /></div>
                            </div>
                            <div>
                                <div className='my-3'><h4>{t("web_portals")}</h4></div>
                                <div className='mt-2'><span>{t("web_text1")}</span></div>
                                <div className='mt-2'><span>{t("web_text2")}</span></div>
                                <div className='mt-2'><span>{t("web_text3")}</span></div>
                                <div className='mt-2'><span>{t("web_text4")}</span></div>
                                <div className='mt-2'><span>{t("web_text5")}</span></div>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-3 d-flex justify-content-center'>
                        <div className='item'>
                            <div className='d-flex justify-content-center align-items-center w-100'>
                                <div className='logo'><img src={custom} alt='' /></div>
                            </div>
                            <div>
                                <div className='my-3'><h4>{t("custom_software")}</h4></div>
                                <div className='mt-2'><span>{t("custom_text1")}</span></div>
                                <div className='mt-2'><span>{t("custom_text2")}</span></div>
                                <div className='mt-2'><span>{t("custom_text3")}</span></div>
                                <div className='mt-2'><span>{t("custom_text4")}</span></div>
                                <div className='mt-2'><span>{t("custom_text5")}</span></div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default Explore
